import React from 'react';
import { SpacingStack } from '@withjoy/joykit';
import { LayoutShell } from '../../components/LayoutShell';
import { usePaymentMethodController } from './PaymentMethod.controller';
import { ContentHeader, CtaGroup, IntegratedGiftCard, PaymentMethodSelector, PrimaryCta, SecondaryCta } from '@apps/registry/guest/components/CheckoutDialog/components';
import { PaymentMethodSelectors } from './PaymentMethod.selectors';
import { useRoutePaths } from '@apps/registry/guest/GuestRegistry.routes';
import { useHistory, useRouterHelper } from '@shared/core';
import { LoadingExpressCheckoutElement } from '@shared/core/stripe';
import { useGuestRegistryTelemetry } from '@apps/registry/guest/GuestRegistry.telemetry';
import { DonationFundPaymentMethodEnum } from '@graphql/generated-base';

export const PaymentMethod = () => {
  const { isCashFundType, options, handleSubmit, onUpdatePaymentMethod, currentPaymentMethod, translations, eventDisplayName, isLoading, amount, enableJoyCredit, registryItem } =
    usePaymentMethodController();
  const { title, cta, description, descriptionDonation, enterCardManually } = translations;
  const routePaths = useRoutePaths();
  const router = useRouterHelper();
  const history = useHistory();
  const telemetry = useGuestRegistryTelemetry();

  return (
    <LayoutShell {...PaymentMethodSelectors.ContainerElement}>
      <LayoutShell.Header mobilePlacement={isCashFundType ? 'float' : 'static'} />
      <LayoutShell.Body>
        <LayoutShell.MediaPanel>
          <IntegratedGiftCard mobileRenderBehavior={isCashFundType ? 'fullBleed' : 'card'} />
        </LayoutShell.MediaPanel>
        <LayoutShell.ContentPanel>
          <ContentHeader>
            <ContentHeader.Hed>{title()}</ContentHeader.Hed>
            <ContentHeader.Dek>{isCashFundType ? description({ host: eventDisplayName }) : descriptionDonation({ fundName: eventDisplayName })}</ContentHeader.Dek>
          </ContentHeader>
          <form onSubmit={handleSubmit}>
            <SpacingStack
              spacing={7}
              marginTop={6}
            >
              <PaymentMethodSelector
                value={currentPaymentMethod}
                options={options}
                onChange={onUpdatePaymentMethod}
              />
              <CtaGroup>
                <LoadingExpressCheckoutElement
                  onParentClick={event => {
                    telemetry.expressCheckoutClicked({ ...event, source: 'CheckoutDialog_PaymentMethod' });
                    history.push(router.buildPath(routePaths.itemCheckout.goToPath(registryItem.id, Math.round(amount * 100).toString())));
                  }}
                  showFallback={!enableJoyCredit}
                  disablePaymentEvents={true}
                  onConfirm={() => {}}
                  onReady={event => telemetry.expressCheckoutElementReady({ ...event, source: 'CheckoutDialog_PaymentMethod' })}
                  options={{ buttonHeight: 50 }}
                  upperContent={
                    <SecondaryCta
                      {...PaymentMethodSelectors.SelectPaymentMethodButton}
                      disabled={!currentPaymentMethod}
                      type="submit"
                      loading={isLoading}
                    >
                      {currentPaymentMethod === DonationFundPaymentMethodEnum.joyCredit ? enterCardManually() : cta()}
                    </SecondaryCta>
                  }
                  fallbackContent={
                    <PrimaryCta
                      {...PaymentMethodSelectors.SelectPaymentMethodButton}
                      disabled={!currentPaymentMethod}
                      type="submit"
                      loading={isLoading}
                    >
                      {cta()}
                    </PrimaryCta>
                  }
                />
              </CtaGroup>
            </SpacingStack>
          </form>
        </LayoutShell.ContentPanel>
      </LayoutShell.Body>
    </LayoutShell>
  );
};
